import { useState, Key, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IVehicleDetail } from "@/views/base/customerFiles/vehicle/vehicleType";
import useGlobalModel from "@/model/globalModel";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { IStockStatisticSearch, IStockStatisticDetail, stockStatisticService } from "@/views/stock/statistic/stockStatisticService";
import { ISaleOrderFields, IDetailList, IPurchaseStockSearch, IPurchaseStock } from "../../saleOrderTypes"
import { IVRMshelfDetail } from "@/views/base/warehouse/warehouseTypes";
import { saleOrderService } from "../../saleOrderService"
import { formatNum, IsUseDefaultBentity, transPgToPagination } from "@/utils/utils";
import { ISearchPage } from "@/types/ScmTypes";
import { globalPrompt } from "@/components/message";
import { DictCodeEnmu, sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { convertRes2Blob } from "@/utils/exportFile";
import { useLockFn } from "ahooks";
import { ISalesTypeEnum } from "@/types/ScmEnums";
import { message } from "antd";

export type ISaleOrderDescType = {
    numAll: number,
    itemNumAll: number,
    totalAll: number,
    notTotalAll: number,
    discountAll: number,
    [key: string]: any
}


//这里为了继承一个弹框列表的自定义属性值
export interface IMaterialDetailModel extends IPurchaseStock {
    num: number,
    price?: number,
    discountRate?: number | string
}
export const useSaleOrderDetailModel = createModel(function () {
    const { user, shopAndOrg, beShopDs } = useGlobalModel()
    const { shopId, shopName } = shopAndOrg

    const [addModalVisible, setAddModalVisible] = useState<boolean>(false)  //新增商品弹框
    const [vehicleEditAll, setVehicleEditAll] = useState<IVehicleDetail[]>([])//实时切换车辆 编辑
    const [vehicleAddAll, setVehicleAddAll] = useState<IVehicleDetail[]>([])//实时切换车辆 新增
    const initDesc = {
        numAll: 0,  //数量
        itemNumAll: 0, //项数
        totalAll: 0,//总计
        discountAll: 0,//折扣
        notTotalAll: 0,//折前总计
    }
    const initForm = {
        shopId,
        shopName,
        favorableAmount: 0,
        salesTypeName: "正常销售",
        salesTypeCode: "sales-type.normal-sales",
        priceTypeName: "零售价",
        priceTypeCode: "price-selection.retail",
        // bentityCode: IsUseDefaultBentity(shopId) ? DictCodeEnmu.BENTITY_BJ_YH_AUTO_SERVICE : "",
        // bentityName: IsUseDefaultBentity(shopId) ? beShopDs.find(item => item.value === DictCodeEnmu.BENTITY_BJ_YH_AUTO_SERVICE)?.label : ""
        bentityName: beShopDs.find((item: any) => item.value === "bentity.hd")?.label ?? "",
        bentityCode: "bentity.hd",
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParam: any = {};
    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<ISaleOrderFields>(initForm)
    //新增详情列表
    const [detailAddList, setDetailAddList] = useState<IDetailList[]>([])
    //新增详情列表选中行
    const [detaiAddDataRowKeys, setDetaiAddDataRowKeys] = useState<Key[]>([]);
    const [detaiAddDataRow, setDetaiAddDataRow] = useState<IDetailList[]>([]);
    const [addDesc, setAddDesc] = useState<ISaleOrderDescType>(initDesc)
    const [addSaleType, setAddSaleType] = useState<ISalesTypeEnum>()
    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<ISaleOrderFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    const [lookDesc, setLookDesc] = useState<ISaleOrderDescType>(initDesc)

    //详情数据
    const [detailEditForm, setDetailEditForm] = useState<ISaleOrderFields>({})
    //详情列表参数
    const [detailDataSource, setDetailDataSource] = useState<IDetailList[]>([]);
    //详情表格选中行
    const [detailDataRowKeys, setDetailDataRowKeys] = useState<Key[]>([]);
    const [detailDataRow, setDetailDataRow] = useState<IDetailList[]>([]);

    const [editDesc, setEditDesc] = useState<ISaleOrderDescType>(initDesc)

    //配件列表配置
    const [workDataSource, setWorkDataSource] = useState<IMaterialDetailModel[]>([])
    const [searchWorkData, setSearchWorkData] = useState<IPurchaseStockSearch>(initSearchParam)
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<IMaterialDetailModel[]>([]);
    //表单改变或表格数据发生改变时，控制功能按钮的启用禁用
    const [topButsControl, setTopButsControl] = useState<boolean>(false)
    const [saveLoading, setSaveLoading] = useState<boolean>(false); //  保存按钮
    useEffect(() => {
        setDetailAddForm({ ...initForm, shopId, shopName });
    }, [shopId])
    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<IVRMshelfDetail[]>([]);
    //设置底部总数展示（查看|编辑|查看）
    useEffect(() => {
        let newDesc: ISaleOrderDescType = { ...initDesc };
        detailDataSource && detailDataSource.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.totalAll += Number(item.amount);
            newDesc.notTotalAll += Number(item.notAmount);
            newDesc.discountAll += Number(item.amount) - Number(item.notAmount)
        });
        if ("favorableAmount" in detailEditForm) {
            newDesc.totalAll = newDesc.totalAll - Number(detailEditForm.favorableAmount);
            newDesc.discountAll = newDesc.discountAll + Number(detailEditForm.favorableAmount)
        }
        newDesc.itemNumAll = detailDataSource && detailDataSource.length
        setEditDesc(newDesc);
    }, [detailDataSource, detailEditForm])

    useEffect(() => {
        let newDesc: ISaleOrderDescType = { ...initDesc };
        detailAddList && detailAddList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.totalAll += Number(item.amount);
            newDesc.notTotalAll += Number(item.notAmount);
            newDesc.discountAll += Number(item.notAmount) - Number(item.amount)
        });
        if ("favorableAmount" in detailAddForm) {
            newDesc.totalAll = newDesc.totalAll - Number(detailAddForm.favorableAmount);
            newDesc.discountAll = newDesc.discountAll + Number(detailAddForm.favorableAmount)
        }
        newDesc.itemNumAll = detailAddList && detailAddList.length
        setAddDesc(newDesc);
    }, [detailAddList, detailAddForm])

    useEffect(() => {
        let newDesc: ISaleOrderDescType = { ...initDesc };
        detailLookList && detailLookList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.totalAll += Number(item.amount);
            newDesc.notTotalAll += Number(item.notAmount);
            newDesc.discountAll += Number(item.amount) - Number(item.notAmount)
        });
        if ("favorableAmount" in detailLookForm) {
            newDesc.totalAll = newDesc.totalAll - Number(detailLookForm.favorableAmount);
            newDesc.discountAll = newDesc.discountAll + Number(detailLookForm.favorableAmount)
        }
        newDesc.itemNumAll = detailLookList && detailLookList.length
        setLookDesc(newDesc);
    }, [detailLookList, detailLookForm])

    //新增表单缓存
    const updateAddFormVal = (val: ISaleOrderFields) => {
        let newVal = val
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: ISaleOrderFields) => {
        let newVal = val
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }
    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await saleOrderService.one(id);
        // return console.log(retData)
        const { details, ...from } = retData
        const newDetails = details?.map((item) => {
            return {
                ...item,
                notAmount: +formatNum(Number(item.num) * Number(item.price)),
                termNum: Number(item.num) + Number(item.inventoryNum), //判断编辑数量的条件
                detailsId: item.id,
            }
        })
        if (retData) {
            let fileList: any = []
            const { md5, fileName } = from
            if (md5) {
                fileList = [
                    {
                        uid: md5,
                        status: 'done',
                        name: fileName,
                        response: {
                            retData: md5,
                        },
                    },
                ]
            }
            from.fileList = fileList
            if (pattern == "edit") {
                setDetailDataSource(newDetails as IDetailList[] ?? [])
                setDetailEditForm(from)
                setTopButsControl(false)
            } else if (pattern == "look") {
                setDetailLookForm(from);
                setDetailLookList(newDetails as IDetailList[] ?? [])
            }
        }
    }
    //关闭弹框
    const resetWorkloadData = async () => {
        setSearchWorkData({} as any);
        workloadData(initPgCfg, {} as any);
    }



    //加载配件数据
    const workloadData = async (page?: ISearchPage, searchValue: IPurchaseStockSearch = searchWorkData) => {
        const searchParams = {
            ...searchValue,
            // ...shopAndOrg,
            ...sourceAppOrBranch,
            shopName: detailEditForm?.shopName ?? detailAddForm?.shopName,
            shopId: detailEditForm?.shopId ?? detailAddForm?.shopId,
            shopType: "1",
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await saleOrderService.stock(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            return {
                ...item,
                num: 1,
            }
        })
        setWorkPgCfg(transPgToPagination(pg));
        setWorkDataSource(newRecords);
    }

    //添加到详情列表 包含导入
    const transformsToPoDetailList = (mode: string, selectedList = addDataSource) => {
        let detailList = mode === "edit" ? detailDataSource : detailAddList;
        const repetition: string[] = [];
        const newDetailData: IDetailList[] = []
        selectedList.forEach(Item => {
            let isSelect = detailList?.find(item => item.detailsId === Item.id);
            if (!isSelect) {
                let { id, materialCode, materialName, inventoryNum, availableStock, num, amount, price, discountRate, ...params } = Item;
                price = +(price ?? 0);
                discountRate = +(discountRate ?? 100);
                newDetailData.push({
                    ...Item,
                    inventoryNum: availableStock,
                    price,
                    discountRate,
                    notAmount: +formatNum(num * price),
                    amount: +formatNum((num * price * discountRate) / 100),
                    id: "",
                    stockId: Item.id,
                    detailsId: id,
                    purchaseId: id
                });
            } else {
                repetition.push(Item.materialName as string);
            }
        });
        (mode === "edit" ? setDetailDataSource : setDetailAddList)([...detailList, ...newDetailData])
        repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，采购单号相同，重复的将不在添加。`, type: "warning" });
    }

    //删除详情列表数据
    const detailDetailList = async (mode: string, Material?: IDetailList) => {
        if (mode == "add") {
            const filterDetailList = Material ? detailAddList.filter(el => !!!(Material.detailsId === el.detailsId)) : detailAddList.filter(el => !!!detaiAddDataRowKeys.find(ele => ele === el.detailsId));
            // const filterDetailList = detailAddList.filter(el => !!!detaiAddDataRowKeys.find(ele => ele === el.detailsId));
            setDetailAddList(filterDetailList)
            globalPrompt("message", { text: `删除成功`, type: "success" });
            setDetaiAddDataRowKeys([]);
            setDetaiAddDataRow([]);
        } else if (mode == "edit") {
            const backendDetailList: any = Material ? Material.id ? [{ id: Material.id }] : [] : detailDataRow.reduce((all: object[], next) => {  //前端页面维护的需要删除的id
                if (next.id) {
                    all.push({ id: next.id });
                }
                return all;
            }, []);

            //删除详情列表调用的方法
            const deleteData = () => {
                const filterDetailList = Material ? detailDataSource.filter(el => !!!(Material.detailsId === el.detailsId)) : detailDataSource.filter(el => !!!detailDataRowKeys.find(ele => ele === el.detailsId));
                // const filterDetailList = detailDataSource.filter(el => !!!detailDataRowKeys.find(ele => ele === el.materialCode))
                setDetailDataSource(filterDetailList)
                globalPrompt("message", { text: `删除成功`, type: "success" });
                setDetailDataRowKeys([]);
                setDetailDataRow([]);
            }

            if (backendDetailList.length > 0) {
                await saleOrderService.materialDelete({ ids: backendDetailList, saleOrderCode: detailEditForm.saleOrderCode as string }).then(res => {
                    if (res.retData) {
                        deleteData()
                    } else {
                        globalPrompt("message", { text: `删除失败`, type: "success" });
                    }
                })
            } else {
                deleteData()
            }


        }
    }
    //表单配件校验 (开单数量不能为0)
    const verifyGoods = (mode: string): boolean => {
        let goods: IDetailList[] = mode === "edit" ? detailDataSource : detailAddList;

        let zeroNum = goods.filter((item: IDetailList) => (Number(item.price) < Number(item.latestPurPrice)));
        if (zeroNum.length) {
            message.warning(`${zeroNum.map(item => `【${item.materialName}】此配件的开单金额不能低于采购入库价${item.latestPurPrice} `).join()}请重新填写`)
            return false;
        }
        return true;
    }
    //表单计算校验 (计算主单信息与配件每一项)
    const formComputeRule = (mode: string): boolean => {
        let goods = mode === "edit" ? detailDataSource : detailAddList;
        let { totalAll } = mode === "edit" ? editDesc : addDesc;
        totalAll = +formatNum(totalAll);//采购总金额
        let goodsTotal: number = 0;
        goods.forEach(item => {
            let { amount } = item as { amount: number }
            goodsTotal += amount
        })
        if (+formatNum(goodsTotal) !== totalAll) {
            message.warning(`详情销订总金额${+formatNum(goodsTotal)}与表单销订总金额不符`);
            return false;
        }
        return true
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: ISaleOrderFields) => {
        try {
            let newParams = {
                ...params,
                details: detailAddList,
                createUser: user.username,
                // ...shopAndOrg,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await saleOrderService.insert(newParams);
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: ISaleOrderFields) => {
        try {
            let newParams = {
                ...params,
                details: detailDataSource,
                updateUser: user.username,
                // ...shopAndOrg,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await saleOrderService.update(newParams);
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type?: string) => {
        setDetailAddList([]);
        setDetailAddForm({})
    }
    const resetEditCatch = async (type?: string) => {
        setDetailEditForm({});
        setDetailDataSource([]);
    }
    const downloadTpl = async () => {
        let result = await saleOrderService.downloadTpl();
        convertRes2Blob(result)
    }
    const onTransfer = useLockFn(async (planCode: string) => {
        let { retData } = await saleOrderService.transfer(planCode);
        return retData

    })
    // const warehousing = async () => {
    //     let { id, purchaseCode } = detailEditForm
    //     let paramas = {
    //         id,
    //         purchaseCode,
    //         storekeeper: user.username
    //     }
    //     let { retData } = await saleOrderService.warehousing(paramas);
    //     return retData
    // }
    // const onSettle = async () => {
    //     let { id, purchaseCode } = detailEditForm
    //     let paramas = {
    //         id,
    //         purchaseCode,
    //         reckoner: user.username
    //     }
    //     let { retData } = await saleOrderService.settle(paramas);
    //     return retData
    // }
    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [historyRow, setHistoryRow] = useState<IStockStatisticDetail>({})
    const [consumeHistoryVisible, setConsumeHistoryVisible] = useState<boolean>(false) //消费记录展示
    const [consumeHistoryModel, setConsumeHistoryModel] = useState<{ customerName: string }>({ customerName: "" }) //消费记录参数
    const [repairHistoryModel, setRepairHistoryModel] = useState<boolean>(false) //维修历史
    return {

        vehicleEditAll, setVehicleEditAll,
        vehicleAddAll, setVehicleAddAll,
        // data 
        addModalVisible,
        initPgCfg,
        detailAddForm,
        detailAddList,
        detaiAddDataRow,
        addDesc,
        detailLookForm,
        detailLookList,
        lookDesc,
        detailDataSource,
        detailDataRowKeys,
        detailDataRow,
        detailEditForm,
        editDesc,
        workDataSource,
        searchWorkData,
        workPgCfg,
        addDataSource,
        shelfAllList,
        detaiAddDataRowKeys,
        // model
        setAddModalVisible,
        setDetailAddForm,
        setDetailAddList,
        setDetaiAddDataRow,
        setAddDesc,
        setDetailLookForm,
        setDetailLookList,
        setLookDesc,
        setDetailDataSource,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailEditForm,
        setEditDesc,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetWorkloadData,
        workloadData,
        transformsToPoDetailList,
        detailDetailList,
        insertDetail,
        editDetail,
        resetAddCatch,
        resetEditCatch,
        setShelfAllList,
        setDetaiAddDataRowKeys,
        downloadTpl,
        initForm,
        topButsControl, setTopButsControl,
        onTransfer,
        historyVisible, setHistoryVisible,
        historyRow, setHistoryRow,
        consumeHistoryModel, setConsumeHistoryModel,
        consumeHistoryVisible, setConsumeHistoryVisible,
        repairHistoryModel, setRepairHistoryModel,
        addSaleType, setAddSaleType,
        formComputeRule,
        verifyGoods,
        saveLoading, setSaveLoading
    }
});